/*------------------------------------*\
    MODULES
\*------------------------------------*/
import loadGoogleMapsApi from "load-google-maps-api";
import $ from "jquery";
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/modal';

/*------------------------------------*\
    GOOGLE MAP
\*------------------------------------*/
class GoogleMap {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    /*-------------------------------------------------*\
        INIT
    \*-------------------------------------------------*/
    init() {
        let self = this;
        let mapContainer = document.querySelector('.js-map');
        let apiKey = self.elem.getAttribute('data-key');
        let apiEndpoint = self.elem.getAttribute('data-endpoint');

        loadGoogleMapsApi({ key: apiKey }).then(function (googleMaps) {
            if (typeof (mapContainer) != 'undefined' && mapContainer != null) {
                var map,
                    locations,
                    infoWindow = new google.maps.InfoWindow();

                $.get(`${apiEndpoint}.json`, function (data) {
                    locations = data.markers;

                    var mapOptions = {
                        zoom: 14,
                        center: new google.maps.LatLng(51.1493563, -0.4530876),
                        disableDefaultUI: true,
                        zoomControl: true,
                        maxZoom: 14,
                        styles: [{ "featureType": "all", "elementType": "labels.text.fill", "stylers": [{ "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 }] }, { "featureType": "all", "elementType": "labels.text.stroke", "stylers": [{ "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 }] }, { "featureType": "all", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#fefefe" }, { "lightness": 20 }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 }] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 20 }] }, { "featureType": "landscape", "elementType": "geometry.fill", "stylers": [{ "saturation": "0" }, { "lightness": "0" }, { "gamma": "1" }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 21 }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#dedede" }, { "lightness": 21 }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }, { "lightness": 17 }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 18 }] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 16 }] }, { "featureType": "transit", "elementType": "geometry", "stylers": [{ "color": "#f2f2f2" }, { "lightness": 19 }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#e9e9e9" }, { "lightness": 17 }] }, { "featureType": "water", "elementType": "geometry.fill", "stylers": [{ "color": "#e1edf4" }] }]
                    };

                    map = new google.maps.Map(mapContainer, mapOptions);

                    // Create the marker image
                    var image = {
                        url: '/assets/images/map-marker.png',
                        size: new google.maps.Size(71, 85),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(35, 38)
                    };

                    // Create the bounds object, which will be configure later based on the marker locations
                    var bounds = new google.maps.LatLngBounds();

                    for (var i = 0; i < locations.length; i++) {
                        var location = locations[i];
                        var latLng = new google.maps.LatLng(location.lat, location.lng);

                        var marker = new google.maps.Marker({
                            position: latLng,
                            map: map,
                            icon: image,
                            title: location.title
                        });

                        (function (marker, location) {
                            google.maps.event.addListener(marker, "click", function (e) {
                                var content = '';
                                var address = location.address.split(', ').join(',</br>');

                                content = content.concat('<div class="col-md-12 float-left">');

                                if (typeof (location.image) != 'undefined' && location.image != null) {
                                    content = content.concat('<img class="float-right" src="' + location.image + '">');
                                }

                                content = content.concat('<p>' + address + '</p>');

                                if (typeof (location.link) != 'undefined' && location.link != null) {
                                    content = content.concat('<a href="' + location.link + '">' + location.link + '</a>');
                                }

                                if (typeof (location.email) != 'undefined' && location.email != null) {
                                    content = content.concat('<p>Email: <a href="mailto:' + location.email + '">' + location.email + '</a></p>');
                                }

                                if (typeof (location.telephone) != 'undefined' && location.telephone != null) {
                                    content = content.concat('<p>Tel: <a href="tel:' + location.telephone + '">' + location.telephone + '</a></p>');
                                }

                                if (typeof (location.content) != 'undefined' && location.content != null) {
                                    content = content.concat('<p>' + location.content + '</a>');
                                }

                                content = content.concat('</div>');

                                $('.modal-title').text(location.title);
                                $('.modal-body').html(content);
                                $('#mapModal').modal('show');
                            });
                        })(marker, location);

                        // Work out the area of the map containing markers
                        bounds.extend(marker.position);

                        // Function to center the map with all markers visible
                        var fitAndCenter = function () {
                            map.setCenter(bounds.getCenter());
                            map.fitBounds(bounds);
                        };

                        fitAndCenter();

                        // Re-center and fit the map when the window is resized
                        google.maps.event.addDomListener(window, 'resize', function () {
                            fitAndCenter();
                        });
                    }
                });
            }
        }).catch(function (error) {
            console.error(error)
        });
    };
}

export default GoogleMap;
